import React from 'react'
import ReactDOM from 'react-dom/client'
import locale from 'antd/locale/vi_VN'
import dayjs from 'dayjs'
import 'dayjs/locale/vi'
import { ConfigProvider } from 'antd'
import App from './modules/inner-iframe/InnerIframe'

dayjs.locale('vi')

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <ConfigProvider locale={locale}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </ConfigProvider>
)
